export default __webpack_public_path__ + "static/018-6ac6328b0506d9ae16f29444236e4164.jpg";